import React from 'react';
import styled from '@emotion/styled';

import { COLORS3 as COLORS, FONT, MEDIA_QUERY } from '../../../../../styles/emotion';

import OnboardPane from '../../../OnboardPane';
import { defaultHedStyles } from '../../../OnboardPane/OnboardPane.styles';

const tablet =
  'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/onboard/NamesAndDate_tablet.jpg';
const desktop =
  'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/onboard/NamesAndDate_desktop.jpg';

const imgSrcs = {
  mobile: tablet,
  tablet,
  desktop,
  alt: '',
};

const Hed = styled.h2`
  ${defaultHedStyles};
  ${MEDIA_QUERY.NOT_MOBILE} {
    ${FONT.textSizeRegular(FONT.FONT_SIZE_SEMI_HUGE)}
  }
`;

const hed = (
  <Hed>
    For all the <strong>teamwork</strong> <br /> along the way
  </Hed>
);

const NamesAndDate = (): JSX.Element => {
  return (
    <OnboardPane hed={hed} showLogo bgColor="" logoColor={COLORS.WHITE_100} imgSrcs={imgSrcs} />
  );
};

export default NamesAndDate;
